import { Injectable } from '@angular/core';
import { MethodsService } from 'src/app/core/http/method.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HandlerService } from 'src/app/core/handlers/handlers.service';
import { environment as params } from 'src/environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService extends MethodsService {

  private currency = new BehaviorSubject<boolean>(false);
  public currencyChange$ = this.currency.asObservable();
  public currencyVar: boolean = false;
  public paramsBusqueda: any = [];
  public totalRes: any = [];
  public doScroll: boolean = true;
  
  constructor(_HandlerService: HandlerService, http: HttpClient, private http2: HttpClient) {
    super(_HandlerService, http);
    this.setApi((<any>params).backend.vuelos);
  }

  /**
     * @description Obtener búsqueda
     * @returns Arreglo de objetos de itinerario
     */
    getRetrieveFlights(busqueda) {
      this.paramsBusqueda = busqueda;
      //console.log('Params busqueda', busqueda);
      //return this.http2.get('http://192.241.132.55:3000/result') //ElihuDíazAPI
      return this.post('flights/filter', busqueda)
        .map((data) => {
          // return data.data;
          return data;
        })
        .catch((err) => {
          return err;
        });
    }


    /**
     * @description Obtener lista de aerolíneas
     * @returns Arreglo de objetos de aerolíneas
     */
    getAirlines() {
      return this.get('flights/airlines', '')
        .map((data) => {
          return data.data;
        })
        .catch((err) => {
          return err;
        });
    }


    /**
     * @description Obtener lista de aeropuertos
     * @returns Arreglo de objetos de aeropuertos
     */
  getAirports(byGroup = false) {
    let url = "flights/airports";
    if (byGroup) {
      url = "air/flights/airportsGroup";
    }
    return this.get(url, "")
      .map((data) => {
        return data.data;
      })
      .catch((err) => {
        return err;
      });
  }

  
    /**
     * @description Obtener valor de dolar
     * @returns Arreglo de objetos de dolar y peso
     */
    getExchangeRates(){
      return this.http2.post('https://web-back.mundojoven.com/flight_back/flights/exchangeRates', {"country": "mexico"})
        .map(data => {
          return data;
        })
        .catch((err) => {
          return err;
        });
    }

    public getRegime () {
      let xmls = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/"> <soapenv:Header/> <soapenv:Body> <tem:GetCatalogRF/> </soapenv:Body> </soapenv:Envelope>'
      var url = 'https://intapi.mundojoven.com/MJService.asmx'
      return this.http2.post(url, xmls, { headers: new HttpHeaders({
        'Content-Type':  'text/xml',
        'Accept':  '*/*'
        }), responseType: 'text'
      });
    }
  
    public getAddress (address) {
      var satData = '<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:tem="http://tempuri.org/">'
      satData += '<soapenv:Header/>'
      satData += '<soapenv:Body>'
      satData += '<tem:GetAddresses>'
      satData += '<tem:addressRq>'
      satData += '<tem:cp>' + address.cp + '</tem:cp>'
      satData += '<tem:estado>' + address.estado + '</tem:estado>'
      satData += '<tem:municipio>' + address.municipio + '</tem:municipio>'
      satData += '<tem:localidad>' + address.localidad + '</tem:localidad>'
      satData += '<tem:colonia>' + address.colonia + '</tem:colonia>'
      satData += '</tem:addressRq>'
      satData += '</tem:GetAddresses>'
      satData += '</soapenv:Body>'
      satData += '</soapenv:Envelope>'
      var url = 'https://intapi.mundojoven.com/MJService.asmx'
      return this.http2.post(url, satData, { headers: new HttpHeaders({
        'Content-Type':  'text/xml',
        'Accept':  '*/*'
        }), responseType: 'text'
      });
    }

    public setCurrency(currency){
      this.currency.next(currency);
      return this.currencyVar = currency;
    }

    public getCurrency(){
      return this.currencyVar;
    }
}
